import { Directive, ElementRef, HostBinding, Input } from '@angular/core';
export enum ZenButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Ghost = 'ghost',
  Red = 'red',
  RedGhost = 'redGhost',
  Link = 'link'

}
@Directive({
  selector: '[zenButton]'
})
export class ButtonStyleDirective {
  @Input() zenButton;
  private defaultButton = { type: ZenButtonType.Primary, size: 10, icon: false };
  @Input('zenButton') set button(button: { type: ZenButtonType, size: number, icon: boolean }) {
    if(!button?.type)
      return;
    const iButton = { ... this.defaultButton, ...button };
    if (iButton.icon)
      this.el.nativeElement.classList.add('btn', 'flex', 'flex-row','justify-center', 'rounded', 'items-center', 'text-center', iButton.type, 'h-' + iButton.size, 'min-w-' + iButton.size, 'leading-' + iButton.size, this.provideTextSize(iButton.size));
    else this.el.nativeElement.classList.add('btn', 'flex', 'flex-row', 'items-center', 'rounded', iButton.type, 'h-' + iButton.size, 'leading-' + iButton.size, 'px-5', this.provideTextSize(iButton.size));


  }
  constructor(private el: ElementRef) { }
  provideTextSize(tailwindHeight: number): string {
    if (tailwindHeight < 9)
      return "text-xs"
    if (tailwindHeight <= 10)
      return "text-sm"
    if (tailwindHeight <= 12)
      return "text-lg"
    if (tailwindHeight <= 16)
      return "text-2xl"
    return "text-base";
  }


  @Input('styles') set styles(styles:string) {
    let classNames = "btn rounded flex flex-row gap-2 items-center";
    if (styles?.includes('exp'))
      classNames += ' exp';
    else if (styles?.includes('secondary'))
      classNames += ' cancel';

    else if (styles?.includes('green'))
      classNames += ' green';

    else if (styles?.includes('red'))
      classNames += ' red';
    else if (styles?.includes('ghost'))
      classNames += ' ghost';

    else if (styles?.includes('aiIcon'))
      classNames += ' aiIcon';

    else if (styles?.includes('delete'))
      classNames += ' bg-zen-red bg-opacity-5 text-zen-red';
    else if (this.zenButton) classNames += ' ' + this.zenButton;

    if (styles?.includes('disabled'))
      classNames += ' pointer-events-none opacity-70';



    if (styles?.includes('icon-')) {
      let newStyles = styles.split("icon-")
      classNames += ` h-${newStyles[1]} w-${newStyles[1]} leading-${newStyles[1]} justify-center`;
    }
    else {
      classNames += ' px-5';
    }
    if (styles?.includes('height-')) {
      let newStyles = styles.split("height-")
      classNames += ` h-${newStyles[1]} leading-${newStyles[1]}`;
    }

    const classes = classNames.split(' ').filter(x=> x);
    this.el.nativeElement.classList.add(...classes);
  };



}
